<template>
    <div class="analysis-details">  
        <div class="details-info">
            <el-row> 
                <el-col :span='6'>
                    <b>距离类型：</b>欧氏距离  
                </el-col>
                <el-col :span='6'>
                    <b>聚类方法：</b>最长距离法 
                </el-col>
                <el-col :span='6'>
                    <b>中药个数：</b>20
                </el-col> 
            </el-row>
            <zyJl></zyJl> 
            <clusterTable></clusterTable>
        </div> 
    </div> 
</template>

<script>
import { mapState,mapMutations, mapActions } from 'vuex';
// import reportModel from '../comps/report_model.vue'
// import excavateData from '../comps/excavateData.js'
import modelTip from "../../../components/ui-kit/model_tip.vue"
// import {cluster_getResult,getPinCi} from "../../../io/api.js"
import saveImge from "../../../utils/saveImg.js"
import Toast from '../../../components/ui-kit/toast.vue'
import subjectJson from './subjectJson.js'
import clusterTable from './cluster/cluster_table.vue'

import zyJl from './cluster/zy_jl.vue'
// 加载loading 
export default {
    components: {
        modelTip, 
        Toast, 
        clusterTable,
        zyJl
    },
    data () {
        return {
            labelWidth:'90px',
            searchType:this.$route.query.searchType||'HERB',
            searchRadio:[
                {
                    value:'中药',
                    label:'HERB'
                },
                {
                    value:'症状',
                    label:'SYMP'
                },
            ],
            isShowRecognize:false,
            searchNum:this.$route.query.searchNum||'',
            distanceValue:this.$route.query.distanceValue||'',
            // distanceOptins:excavateData.distanceOptins,
            clusterValue:this.$route.query.clusterValue||'',
            pixel:72,//图片尺寸
            // pixelOptins:excavateData.pixelOptins,
            // clusterOptins:excavateData.clusterOptins,
            displayModeValue:'1',
            // displayMode:excavateData.displayMode,
            isShowReport:false,
            isLoading:false,
            reportName:'',
            cluster_url:'',
            cluster_srcList:[],
            tabeList:subjectJson.cfyy.jl_table,
        }
    },
    computed: {
        // ...mapState({ 
        //     k_table:state=>state.excavate.k_table, 
        // })
        
    },
    mounted () {
        this.getInfo();
        this.getTable(); 
        //类型位中药时显示方剂识别
        this.showRecognize(); 
    },
    methods: {
        // ...mapActions(['saveExport']),
        analysis(){
            if(this.distanceValue==''||this.clusterVal==''){
                this.$message.error('请选择距离类型或聚类方法～')
                return
            }
            this.getInfo();
            // 生成报告需要的elist
            this.getTable();
        },
        //是否显示方剂识别按钮
        showRecognize(){
            if(this.searchType=='HERB'){ 
                this.isShowRecognize=true;
            }else{
                this.isShowRecognize=false;
            }
        },
        getInfo(){
            let param = {
                topValue:this.searchNum,//对数据前几个进行分析
                dataType:this.searchType,//类型
                distance:this.distanceValue,//距离类型
                mapType:this.displayModeValue,//显示方式
                method:this.clusterValue,//聚类方法
                pixel:this.pixel
            }
            this.cluster_url = "";
            this.isLoading=true
            // cluster_getResult(param).then(res=>{
            //     let data = res.data;
            //     if(data&&data.code==0){
            //         this.cluster_url = data.data;
            //         this.showRecognize();
            //     }else{
            //         this.$message.error(data.msg||'请求失败～')
            //     }
            //     this.isLoading=false;
            // })
        },
        // 获取表格数据
        getTable(){  
        },
        // 切换类型的时候重新请求talbeList
        changeRadin(val){
            this.searchType = val;
            this.getTable();
        },
        displayMode_click(val){
            this.displayModeValue = val;
            this.getInfo();
        },
        resolution_click(val){
            this.pixel = val;
            this.getInfo();
        },
        save_pic(){
            saveImge(this.$refs.picurl.src,"聚类分析结果图")
        },
        report(){
            this.isShowReport = true;
        }, 
        go_back(){
            this.$router.push({
                path:'excavate',
                query:{
                    navType:2,
                }
            }) 
        },
        identification(){
            if(this.tabeList){
                //取筛选数量的数据,
                let list=this.tabeList.length>this.searchNum?this.tabeList.splice(0,this.searchNum):this.tabeList;
                let keyArr=[];
                list.forEach(item => {
                    if(item.name){
                        keyArr.push(item.name)
                    }
                });
                this.$nextTick(()=>{
                    this.$router.push({
                        path:'recognizeFj',
                        query:{
                            keyName:keyArr.toString()
                        }
                    }) 
                }) 
            }; 

        },

    }
}
</script>
<style lang="less" scoped>
    @import url('./analysis_details.less');
</style>
<style lang="less"> 
.img_url{
    width: 1100px;
    margin: 20px auto;
    .el-image{
        width: 100%;
    }
}
</style>